module.exports = __webpack_public_path__ + "media/video-poster/cropped-720p-e1bb9175.jpg";